import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { IAssistantMessageSend, AssistantStreamEvent } from '../models/assistant';
import { AssistantStreamParser } from './assistant-stream-parser';
import { BranchService } from '@simac/ui';

@Injectable({ providedIn: 'root' })
export class AssistantChatService {
  private readonly http = inject(HttpClient);
  private readonly branchService = inject(BranchService);

  sendMessage(message: IAssistantMessageSend, messageId: string): Observable<AssistantStreamEvent> {
    const params = this.getParams();
    return new Observable((subscriber) => {
      const parser = new AssistantStreamParser(messageId);

      const subscription = this.http
        .post(
          'api/serviceandsupport/assistant/message/stream',
          { ...message, messageId },
          {
            params,
            observe: 'events',
            responseType: 'text',
            reportProgress: true,
            headers: { Accept: 'text/event-stream' },
          },
        )
        .pipe(timeout({ each: 45000 }))
        .subscribe({
          next: (event) => {
            const text = event.type === HttpEventType.DownloadProgress ? event.partialText : event.type === HttpEventType.Response ? event.body : undefined;
            if (text === undefined || text === null) {
              return;
            }
            try {
              for (const update of parser.read(text)) {
                subscriber.next(update);
              }
              if (parser.finished) {
                subscriber.complete();
              }
            } catch (error) {
              subscriber.error(error);
            }
          },
          error: (error: unknown) => subscriber.error(error),
          complete: () => {
            try {
              parser.assertFinished();
              subscriber.complete();
            } catch (error) {
              subscriber.error(error);
            }
          },
        });
      return () => subscription.unsubscribe();
    });
  }

  private getParams(): HttpParams {
    let params = new HttpParams();
    if (this.branchService.isPersonalSelected()) {
      params = params.append('context', 'Personal');
    } else {
      params = params.append('context', 'Branch');
    }
    return params;
  }
}
